module.exports = __webpack_public_path__ + "static/media/star-logo.e9de287e.svg";